import {useCallingContext} from "../../../context/CallingContext";
import {InCalling} from "./InCalling";
import {BankCall} from "./BlankCall";

const Calling = () => {
  const {room} = useCallingContext();
  return (
      <div className="h-[100%] bg-[black]">
        {room ? <InCalling/> : <BankCall/>}
      </div>
  );
};

export {Calling};
